import { render, staticRenderFns } from "./ConsignmentNoteEdit.vue?vue&type=template&id=b5a60aba&scoped=true&"
import script from "./ConsignmentNoteEdit.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a60aba",
  null
  
)

export default component.exports